// extracted by mini-css-extract-plugin
module.exports = {"reportRoot":"spendBenchmarks_reportRoot__eplqR"};